<template>
  <v-container fluid class="pt-0 mt-0">
    <v-row>
      <v-spacer />
      <v-col cols="12" md="11">
        <v-card class="mx-auto">
          <v-toolbar color="teal" dark class="text-xs-center">
            <v-toolbar-title style="color: white">Chamaerops</v-toolbar-title>

            <v-spacer></v-spacer>
            <v-text-field v-model="searchText" hide-details label="Enter search text" class="ma-0 pa-0">
            </v-text-field>

            <v-btn icon>
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-subtitle class="black-text">
            Chamaerops is the journal of the European Palm Society
          </v-card-subtitle>
          <v-card-text class="black-text">
            <p>
              The Chamaerops archive goes back to our first issue and now contains
              hundreds of articles on palms and other exotic plants. All articles have
              been written by members including botanists, scientists, professional and
              amateur growers, from all around the world. Put simply contributions from
              anyone who is interested in growing palms and other exotic plants in
              temperate climates.
            </p>
            <p class="black-text">
              Please enjoy browsing through the wealth of information that has been built
              up since the society was formed.
            </p>
          </v-card-text>

          <v-tabs v-if="yearsAvailable" next-icon="mdi-arrow-right-bold-box-outline"
            prev-icon="mdi-arrow-left-bold-box-outline" show-arrows>
            <v-tab v-for="year in yearsAvailable" :key="year">
              <v-icon left> mdi-account </v-icon>
              {{ year }}
            </v-tab>

            <v-tab-item v-for="year in yearsAvailable" :key="year">
              <v-card flat>
                <v-toolbar flat color="primary" dark>
                  <v-toolbar-title>Journals From {{ year }}</v-toolbar-title>
                </v-toolbar>
                <v-row class="ma-0 pa-0">
                  <v-col cols="12" v-for="newsletter in currentYearNewsletters(year)" :key="newsletter.id">
                    <v-card class="ma-2 pa-0">
                      <v-toolbar flat color="teal" dark>
                        <v-toolbar-title>{{ newsletter.title }}
                          <v-icon v-if="newsletter.isNew" large color="white"> mdi-new-box </v-icon>
                        </v-toolbar-title>
                        <v-spacer />
                        <v-toolbar-items class="mb-1">
                          <v-list-item-title>
                            {{ formatDateTime(newsletter.issueDate) }}
                          </v-list-item-title>
                        </v-toolbar-items>
                      </v-toolbar>

                      <v-list-item two-line>
                        <v-list-item-avatar rounded size="120px" v-if="newsletter.coverImage">
                          <v-img outlined contain :src="getCoverImageUrl(newsletter.coverImage)" />
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-subtitle class="black-text" style="white-space: inherit" v-html="newsletter.contents">
                          </v-list-item-subtitle>
                          <v-list-item-subtitle class="black-text">Download:
                            <a target="_blank" :href="getPdfUrl(newsletter.pdfFile)">{{ getPdfFilename(newsletter.pdfFile)
                            }}</a>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>

                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
      <v-spacer />
    </v-row>

  </v-container>
</template>

<script>
import dateFunctions from "@/functions/dateFunctions";
import userFunctions from "@/functions/userFunctions";
import serverFunctions from "@/functions/serverFunctions";

export default {
  name: "NewsLetter",
  methods: {
    getPdfUrl(pdfFile) {
      if (!pdfFile) { return }
      return (pdfFile.startsWith("journals")) ? process.env.VUE_APP_AVATAR_BASE_URL_NEW + pdfFile : 'https://wsrv.nl/?url=http://old.palmsociety.org.uk/chamaerops/files/' + pdfFile;
    },
    getPdfFilename(pdfFile) {
      if (!pdfFile) { return }
      return (pdfFile.indexOf("/") > -1) ? pdfFile.substring(pdfFile.lastIndexOf("/") + 1) : pdfFile;
    },
    getCoverImageUrl(pdfFile) {
      if (!pdfFile) { return }
      let coverUrl = (pdfFile.startsWith("journals")) ? process.env.VUE_APP_AVATAR_BASE_URL_NEW + pdfFile : 'https://wsrv.nl/?url=http://old.palmsociety.org.uk/chamaerops/files/' + pdfFile;
      return coverUrl
    },
    getAvatarUrl(avatar) {
      return userFunctions.getFullAvatarUrl(avatar);
    },
    getArticleSummary(articleContent) {
      return articleContent.substring(0, 250);
    },
    unique(value, index, self) {
      return self.indexOf(value) === index;
    },
    hasIssueDate(value) {
      return value.issueDate && value.issueDate.length > 4;
    },
    formatDateTime(datetime) {
      return dateFunctions.formatPalmDate(datetime);
    },
    htmlDecode(input) {
      var doc = new DOMParser().parseFromString(input, "text/html");
      return doc.documentElement.textContent;
    },
    showDialog(newsPost) {
      this.selectedArticle = newsPost;
      this.dialog = true;
    },
    listShouldBeCompacted() {
      return (
        this.$vuetify.breakpoint.name === "xs" || this.$vuetify.breakpoint.name === "ms"
      );
    },
    // downloadFile(filename) {
    //   const url = "http://old.palmsociety.org.uk/chamaerops/files/" + filename;
    //   const options = {
    //     headers: {
    //       filename: filename,
    //     },
    //   };
    //   fetch(url, options)
    //     .then((res) => res.blob())
    //     .then((blob) => {
    //       var file = window.URL.createObjectURL(blob);
    //       window.location.assign(file);
    //     });
    // },
    downloadPDFLabelText() {
      if (this.listShouldBeCompacted()) {
        return "Download";
      } else {
        return "Download PDF";
      }
    },
    async getAPIData() {

      const getJournalRequest = serverFunctions.getDataRequestObject(
        userFunctions.getLoggedInUser()
      );
      this.newsLetterData = await serverFunctions.getPostResponse("/getAllNewsLetters", getJournalRequest);
      userFunctions.updateLastViewed('journals');
    },
    currentYearNewsletters: function (year) {
      return this.filteredAPIData.filter(this.hasIssueDate).filter(
        (newsletter) => newsletter.issueDate.substring(0, 4) == year
      );
    },
  },
  data: () => ({
    dialog: false,
    selectedArticle: null,
    newsLetterData: null,
    searchText: "",
  }),
  computed: {
    yearsAvailable: function () {
      if (this.filteredAPIData) {

        let articlesWithValidIssueDates = this.filteredAPIData.filter(this.hasIssueDate);

        return articlesWithValidIssueDates
          .map((newsletter) => newsletter.issueDate.substring(0, 4))
          .filter(this.unique);
      }
      return null;
    },
    filteredAPIData: function () {
      if (!this.searchText || this.searchText.length == 0) {
        return this.newsLetterData;
      }
      if (this.newsLetterData) {
        return this.newsLetterData.filter(
          (article) => article.title && (article.title.toUpperCase() + article.contents.toUpperCase()).indexOf(this.searchText.toUpperCase()) > -1
        );
      }
      return null;
    },
  },
  beforeMount() {
    this.getAPIData();
  },
};
</script>

<style scoped>
.palm-site-green {
  background-color: rgb(176, 217, 173);
}
</style>
